var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 15.7109V8.71094",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58325 22.7109C7.37818 22.7109 8.83325 21.2559 8.83325 19.4609C8.83325 17.666 7.37818 16.2109 5.58325 16.2109C3.78833 16.2109 2.33325 17.666 2.33325 19.4609C2.33325 21.2559 3.78833 22.7109 5.58325 22.7109Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 8.71094C6.99011 8.71094 8.33325 7.36779 8.33325 5.71094C8.33325 4.05408 6.99011 2.71094 5.33325 2.71094C3.6764 2.71094 2.33325 4.05408 2.33325 5.71094C2.33325 7.36779 3.6764 8.71094 5.33325 8.71094Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 8.71094C20.9901 8.71094 22.3333 7.36779 22.3333 5.71094C22.3333 4.05408 20.9901 2.71094 19.3333 2.71094C17.6764 2.71094 16.3333 4.05408 16.3333 5.71094C16.3333 7.36779 17.6764 8.71094 19.3333 8.71094Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46313 15.7119C5.91313 13.9619 7.51313 12.6619 9.40313 12.6719L12.8331 12.6819C15.4531 12.6919 17.6831 11.0119 18.5031 8.67188",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.c7a1586f5ff1958848c541737c833e1f.svg";
export { ForwardRef as ReactComponent };